<template>
  <v-card>
    <v-card-title style="height: 64px;">
      <span class="title">{{title}}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-container class="py-2" grid-list-md>
        <v-form ref="form" v-model="valid">
          <v-layout>
            <v-flex>
              <v-autocomplete
                :disabled="!newItem"
                :hide-no-data="memberLoading || !search"
                :items="searchSelects"
                :label="'受访人员'"
                :loading="memberLoading"
                :no-data-text="typeof search === 'string' && search.trim()?'没有匹配选项':'输入以搜索'"
                :placeholder="(type === 'admin' || ownerOrg)? search ? '没有可选项':'输入以搜索' : '请先选择受访单位'"
                :rules="[$rules.requiredS()]"
                :search-input.sync="search"
                autofocus
                chips
                deletable-chips
                prepend-icon="$vuetify.icons.person"
                v-model="ownerId"
              >
                <template slot="item" slot-scope="props">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <v-flex align-center justify-between layout row>
                        <span>{{props.item.text}}</span>
                      </v-flex>
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <span class="grey--text caption text-xs-right">{{props.item.subText|| ''}}</span>
                  </v-list-tile-action>
                </template>
                <template slot="append-item">
                  <v-list-tile v-if="searchItems.length >= maxItem && !memberLoading">
                    <v-list-tile-title>
                      <span class="grey--text">仅显示前{{maxItem}}个结果</span>
                    </v-list-tile-title>
                  </v-list-tile>
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <v-autocomplete
                :disabled="orgList.length === 1"
                :items="orgList"
                :loading="orgLoading"
                item-text="name"
                label="所在单位"
                :rules="[$rules.requiredS('请选择受访单位')]"
                :placeholder="type ==='admin' && !ownerId ? '请先选择受访人':'请选择受访单位'"
                prepend-icon="$vuetify.icons.org"
                return-object
                v-model="ownerOrg"
              >
                <template slot="no-data">
                  <v-list-tile>
                    <v-list-tile-title>
                      <span v-if="type ==='admin' && !ownerId" class="grey--text body-2">请先选择受访人</span>
                      <span v-else-if="type ==='admin' && ownerId" class="grey--text body-2">未获取到受访人单位</span>
                      <span v-else class="grey--text body-2">未获取到您管理的单位</span>
                    </v-list-tile-title>
                  </v-list-tile>
                </template>
                <template slot="item" slot-scope="props">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <v-flex align-center justify-between layout row>
                        <span>{{props.item.name}}</span>
                      </v-flex>
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <span class="grey--text caption text-xs-right">{{props.item.code|| ''}}</span>
                  </v-list-tile-action>
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="cancel" color="grey" flat large>取消</v-btn>
      <v-btn :disabled="!valid" :loading="loading" @click="confirm" color="primary" flat large>确定</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  name: 'selectBeVisitDialog',
  props: {
    maxItem: {type: Number, default: 20},
    mustInput: {type: Boolean, default: true},
    objectLabel: {type: String, default: '名称'},
    status: {type: String, default: 'new'},
    rawItem: {type: Object},
    loading: {type: Boolean, default: false},
    params: {type: Object},
    type: {type: String}
  },
  data: () => ({
    orgLoading: false,
    orgList: [],
    valid: false,
    ownerId: '',
    ownerOrg: null,
    search: '',
    searchItems: [],
    memberLoading: false
  }),
  computed: {
    self () {
      return this.$store.state.login.self
    },
    owner () {
      return this.searchItems.find(v => v.id === this.ownerId)
      // let o = Object.assign({}, t)
    },
    searchSelects () {
      let select = []
      this.searchItems.forEach(v => {
        select.push({text: v.name, value: v.id, subText: v.loginId})
      })
      return select
    },
    dark () {
      return this.$vuetify.dark
    },
    readonly () {
      return this.status === 'readonly'
    },
    editing () {
      return this.status === 'edit'
    },
    newItem () {
      return this.status === 'new'
    },
    title () {
      if (this.readonly) {
        return '查看受访人'
      }
      else if (this.editing) {
        return '修改受访人'
      }
      else {
        return '选择受访人'
      }
    }
  },
  watch: {
    ownerId () {
      if (this.owner) {
        // console.log('owenr', this.owner)
        this.orgList = this.owner.orgGroup ? [this.owner.orgGroup] : this.orgList
        if (!this.ownerOrg) {
          this.ownerOrg = this.owner.orgGroup
        }
      }
      else {
        this.orgList = this.orgList.length ? [] : this.orgList
        this.ownerOrg = null
      }
    },
    search: function (val) {
      if (typeof val === 'string' && (!this.mustInput || val.trim())) {
        this.getSelection_()
      }
    }
    // ownerOrg (val) {
    //   if (this.owner && val !== this.owner.orgGroup) {
    //     this.owner.setOrgGroup(val)
    //   }
    // },
  },
  methods: {
    getSelection_: debounce(async function () {
      if ((this.type === 'admin' || this.ownerOrg instanceof Object) &&
        typeof this.search === 'string' && this.search.trim()) {
        this.memberLoading = true
        let group = this.ownerOrg || {}
        let {items} = await this.getSelection({searchValue: this.search, group: group, order: true})
        console.log('get selection', items)
        this.searchItems = items
        this.memberLoading = false
      }
    }, 500),
    async getSelection ({searchValue, group}) {
      try {
        if (this.type === 'admin') {
          return this.$store.dispatch('userAdmin/getUsers', {
            pagination: {page: 1, rowsPerPage: this.maxItem},
            search: {key: 'name', value: searchValue}
          })
        }
        else {
          return this.$store.dispatch('userAdmin/getUsersByGroup', {
            params: {
              pagination: {page: 1, rowsPerPage: this.maxItem},
              search: {key: 'name', value: searchValue},
              order : true,
            },
            group
          })
        }
      }
      catch (e) {
        this.$L.alert('error', {title: '获取受访人时发生错误', message: e.message, raw: e})
      }
    },
    async getAdminOrg () {
      return this.$store.dispatch('reservation/getAdminOrg', this.self)
    },
    async getAdminOrg_ () {
      this.orgLoading = true
      try {
        this.orgList = await this.getAdminOrg()
      }
      catch (e) {
        this.$L.alert('error', {title: '获取受访单位时发生错误', message: e.message, raw: e})
      }
      this.orgLoading = false
    },
    confirm () {
      // logger.debug('submit', this.util.deepClone(this.newConfig))
      if (this.$refs.form.validate()) {
        this.$emit('confirm', {newItem: this.owner, oldItem: this.rawItem, status: this.status})
      }
    },
    cancel () {
      this.$emit('cancel')
    }
  },
  async created () {
    if (this.type !== 'admin') {
      await this.getAdminOrg_()
      if (this.orgList.length > 0) {
        this.ownerOrg = this.orgList[0]
      }
    }
  }
}
</script>

<style scoped>

</style>
